import TextEditorMinimal from '@/components/commons/minimal-tiptap/minimal-editor';
import Sorting from '@/components/sections/builder/elements/body/collection-list-page/sorting';
import { CollectionListPageElementDataType } from '@/components/sections/builder/elements/body/collection-list-page/type';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import InputTab from '@/components/sections/builder/settings/input-tab';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import { ElementProps } from '@/components/sections/builder/types';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as CollectionListPageElementDataType;

  return (
    <div>
      <div className='my-4'>
        <h4 className='mb-3 font-bold'>Header</h4>
        <TextEditorMinimal
          value={data.heading as string}
          onChange={(value) => {
            builder.setElementData(element.id, {
              heading: value,
            });
          }}
          output='html'
          editorProps={{
            attributes: {
              class: 'prose lg:prose-lg prose-blue dark:prose-invert p-2',
            },
          }}
          editable
        />
      </div>
      <div className='mb-4 mt-4 font-bold'>Heading Size</div>
      <InputTab
        defaultValue={data.headingSize}
        options={[
          { label: 'Small', value: 'small' },
          { label: 'Medium', value: 'medium' },
          { label: 'Large', value: 'large' },
        ]}
        onChange={(v) =>
          builder.setElementData(element.id, {
            headingSize: v,
          })
        }
      />
      <div className='py-4 font-bold'>Content Alignment</div>
      <InputTab
        defaultValue={data.contentAlign}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Center', value: 'center' },
          { label: 'Right', value: 'right' },
        ]}
        onChange={(v) => builder.setElementData(element.id, { contentAlign: v })}
      />
      <Sorting
        value={data.sortingCollection}
        onChange={(val) => builder.setElementData(element.id, { sortingCollection: val })}
      />
      <div className='flex flex-col gap-2 pt-4'>
        <span className='font-bold'>Image ratio</span>
        <InputTab
          defaultValue={data.imageRatio}
          options={[
            { label: 'Adapt to image', value: 'adaptToImage' },
            { label: 'Portrait', value: 'portrait' },
            { label: 'Square', value: 'square' },
          ]}
          onChange={(v) =>
            builder.setElementData(element.id, {
              imageRatio: v,
            })
          }
        />
      </div>
      <div className='flex flex-col gap-2 pt-4'>
        <span className=''>Number of columns on desktop</span>
        <InputSlider
          value={data.totalCol || 0}
          max={5}
          onChange={(val) =>
            builder.setElementData(element.id, {
              totalCol: val,
            })
          }
        />
      </div>
      <div className='flex flex-col gap-2 pt-4'>
        <span className='font-bold'>Number of columns on mobile</span>
        <InputSlider
          value={data.totalColMobile || 0}
          max={3}
          onChange={(val) =>
            builder.setElementData(element.id, {
              totalColMobile: val,
            })
          }
        />
      </div>
      <div className='mb-4 mt-4 font-bold'>Font Collection Card Size</div>
      <InputTab
        defaultValue={data.size}
        options={[
          { label: 'Small', value: 'small' },
          { label: 'Medium', value: 'medium' },
          { label: 'Large', value: 'large' },
        ]}
        onChange={(v) =>
          builder.setElementData(element.id, {
            size: v,
          })
        }
      />
      <div className='my-4'>
        <div className='mb-2 mt-4 font-bold'>Color scheme</div>
        <SchemeSetting
          value={data.colorSchemeCollectionList}
          onChange={(theme) => {
            builder.setElementData(element.id, {
              colorSchemeCollectionList: theme,
            });
          }}
        />
      </div>
      <div className='flex flex-col gap-2 py-4'>
        <span className=''>Border radius</span>
        <InputSlider
          value={data.borderRadius || 0}
          max={100}
          min={0}
          onChange={(val) =>
            builder.setElementData(element.id, {
              borderRadius: val,
            })
          }
        />
      </div>
    </div>
  );
}
